import styled from 'styled-components'

const darkColor = props => props.theme.global.colors['dark-2']
const lightColor = props => props.theme.global.colors['white']
const borderColor = props => props.theme.global.colors['light-7']
const darkButtonHoverColor = (props) => props.theme.global.colors['darkButtonHover']
const linkColor = (props) => props.theme.global.colors['blueLink']
const dividerColor = (props) => props.theme.global.colors['divider']
const placeholderColor = (props) => props.theme.global.colors['placeholderColor']

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  background-color: ${lightColor};
  margin: 24px 0;

  @media screen and (max-width:992px) {
    flex-direction: column;
    gap: 8px;
    margin: 16px 0;
  }
`

export const LeftSection = styled.div`
  width: ${props => props.hasShippingInstructions ? "50%" : "100%"};

  @media screen and (max-width:992px) {
    width: 100%;
  }
`

export const Label = styled.p`
  color: ${darkColor};
  font-size: 14px;
  font-weight: 400;
  line-height: 165%;
  margin: 0;
`

export const Value = styled.strong`
  color: ${darkColor};
  font-size: 14px;
  font-weight: 700;
  line-height: 165%;
  margin: 0;
`

export const VerticalLine = styled.div`
  width: 1px;
  background-color: ${borderColor};

  @media screen and (max-width: 992px) {
    display: none;
  }
`

export const ShippingInstructionSection = styled.div`
  width: 50%;

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`

export const DownloadLabelWrapper = styled.div`
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

export const DownloadShippingLabelCTA = styled.button`
  max-width: 292px;
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  border: none;
  font-family: 'Roboto';
  font-size: 16px;
  font-weight: 600;
  line-height: 165%;
  color: ${lightColor};
  border-radius: 4px;
  background-color: ${darkColor};
  cursor: pointer;

  &:hover {
    background-color: ${darkButtonHoverColor};
    border: none;
  }

  @media screen and (max-width: 992px) {
    font-size: 14px;
    height: 40px;
  }
`

export const TextBox = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  & > div {
    min-width: 14px;
  }

  & > p {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 165%;
    color: ${placeholderColor};
    margin: 0;

    @media screen and (max-width: 992px) {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 992px) {
    align-items: flex-start;
    padding: 0 6px;
  }
`

export const ReturnCTA = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  border: none;
  border-radius: 4px;
  background-color: ${darkColor};
  outline: none;
  font-family: 'Roboto';
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: ${lightColor};
  max-width: 292px;
  width: 100%;
  margin: 0 auto;
  cursor: pointer;

  &:hover {
    background-color: ${darkButtonHoverColor};
    border: none;
  }

  @media screen and (max-width:992px) {
    height: 40px;
    font-size: 14px;
  }
`

export const HorizontalLine = styled.div`
  height: 1px;
  background-color: ${dividerColor};
  width: 100%;
  margin-bottom: 24px;

  @media screen and (max-width:992px) {
    margin-bottom: 16px;
  }
`

export const AdditionalInfoSection = styled.div`
  margin: 24px 0;
`

export const FlexBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  line-height: 165%;
`
